module.exports = __webpack_public_path__ + "media/images/thumbs/biology/v_qv_agranular_myeloid_white_blood_cells_3-4e7cbe604ccb4040b7f9b57b6aad385a.jpg";